@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.dropdown-menu-item {
  display: flex;
  justify-items: center;
}

.tag-dropdown-menu-item {
  display: flex;
}

.checkbox {
  align-self: center;
}

.pill {
  margin-left: 10px;
  max-width: calc(100% ~'-' 25px);
}

.no-tags-indicator {
  width: 180px;
  font-size: 13px;
  color: @tag-dropdown--no-tags-indicator--text-color;
  font-style: italic;
  padding: 10px;
  min-height: 30px;
}
